import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import JwtService from "src/app/auth/services/jwtService";

const PinCodeScreen = ({props}) => {
  const { login, password, info, chat_id } = props
  const [extra, setExtra] = useState({});
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [attemptsLeft, setAttemptsLeft] = useState(5);

  const handlePress = (digit) => {
    if (pin.length >= 4) return;

    const newPin = pin + digit;
    setPin(newPin);

    if (newPin.length === 4) {
      // Example: validate PIN (here hardcoded as "1234")
      setTimeout(() => {
        if (newPin == extra?.i) {
          onSubmit({ email: extra.n, password: extra.d , pin:newPin})
        } else {
          const remaining = attemptsLeft - 1;
          setAttemptsLeft(remaining);
          setError("Noto‘g‘ri PIN kod");
          setPin("");

          if (remaining <= 0) {
            alert("PIN urinishlar tugadi ❌");
          }
        }
      }, 1000);
    }
  };

  const handleDelete = () => {
    setPin(pin.slice(0, -1));
  };


  useEffect(() => {
    if (info) {
      const decodedData = JSON.parse(atob(info));
      setExtra(decodedData)
    }
  }, [info]);

  function onSubmit({ email, password, pin }) {
    JwtService
      .signInWithEmailAndPassword(email, password ,pin, chat_id)
      .then((user) => {
        // No need to do anything, user data will be set at app/auth/AuthContext

        if (user.response.status == 401) {
          setValue('password', '');
          dispatch(showMessage({ message: `${t("IncorrectUsernameOrPassword")}`, variant: 'error', }));

        }

      });
  }

  const renderDots = () => {
    return (
      <div className="flex justify-center gap-24 my-12">
        {[0, 1, 2, 3].map((i) => (
          <div
            className={`w-96 h-48 rounded-full border-2 flex items-center justify-center  ${pin[i] ? "!border-blue" : "border-gray-400"
              }`}>
            <div
              key={i}
              className={`w-16 h-16 rounded-full   ${pin[i] ? "bg-blue" : ""
                }`}
            />
          </div>
        ))}
      </div>
    );
  };

  const digits = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

  const handleDeletePin =() =>{
    var info = localStorage.removeItem("store_info")
    window.location.reload()
  }

  return (
    <div className="min-h-screen flex flex-col justify-between items-center p-32 bg-white ">
         <div className="w-full text-right mt-10">
        <Button onClick={handleDeletePin} color="secondary">Tizimga qayta kirish</Button>
        </div>
      <div className="w-full text-center mt-10">
        <h2 className="text-2xl font-semibold mb-2">PIN-kodni tasdiqlang</h2>
      
        {renderDots()}
        {error && (
          <div className="text-red-600 text-sm">
            {error}
            <br />
            {attemptsLeft} urinish qoldi
          </div>
        )}
      </div>

      <div className="grid grid-cols-3 gap-32 w-full max-w-sm mx-auto">
        {digits.slice(0, 9).map((digit) => (
          <button
            key={digit}
            onClick={() => handlePress(digit)}
            className="aspect-square rounded-full bg-gray-100 text-[32px] font-[700] shadow text-black active:bg-blue active:text-white"
          >
            {digit}
          </button>
        ))}

        <div></div>
        <button
          onClick={() => handlePress("0")}
          className="aspect-square rounded-full bg-gray-100 text-[32px] font-[700] shadow text-black"
        >
          0
        </button>
        <button
          onClick={handleDelete}
          className="aspect-square rounded-full text-[32px] font-[700] text-black"
        >
          ⌫
        </button>
      </div>

      <div className="h-10"></div>
    </div>
  );
};

export default PinCodeScreen;
